import { dePack } from './de/index.js';
import { frPack } from './fr/index.js';
import { trPack } from './tr/index.js';
import type { LocalePack } from './types.js';
import type { MarketLocale } from '../../apps.js';

const PACKS: Readonly<Record<MarketLocale, LocalePack | null>> = { tr: trPack, fr: frPack, de: dePack };

export function hasLocalePack(locale: MarketLocale): boolean {
  return PACKS[locale] !== null;
}

/** The vocabulary for a market. Throws for a market with no pack yet. */
export function localePack(locale: MarketLocale): LocalePack {
  const pack = PACKS[locale];
  if (pack === null) throw new Error(`No synthetic locale pack for '${locale}'`);
  return pack;
}
